var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90039 19C12.4199 19 14.8363 17.9991 16.6179 16.2175C18.3995 14.4359 19.4004 12.0196 19.4004 9.5C19.4004 6.98044 18.3995 4.56408 16.6179 2.78249C14.8363 1.00089 12.4199 0 9.90039 0C7.38083 0 4.96447 1.00089 3.18288 2.78249C1.40128 4.56408 0.400391 6.98044 0.400391 9.5C0.400391 12.0196 1.40128 14.4359 3.18288 16.2175C4.96447 17.9991 7.38083 19 9.90039 19ZM14.3025 7.96456C14.5188 7.7406 14.6385 7.44063 14.6358 7.12927C14.633 6.81792 14.5082 6.52008 14.288 6.2999C14.0678 6.07973 13.77 5.95484 13.4586 5.95214C13.1473 5.94943 12.8473 6.06913 12.6233 6.28544L8.71289 10.1959L7.17745 8.66044C6.95349 8.44413 6.65352 8.32443 6.34216 8.32714C6.03081 8.32984 5.73297 8.45473 5.51279 8.6749C5.29262 8.89507 5.16773 9.19291 5.16503 9.50427C5.16232 9.81563 5.28202 10.1156 5.49833 10.3396L7.87333 12.7146C8.09602 12.9372 8.39801 13.0622 8.71289 13.0622C9.02777 13.0622 9.32976 12.9372 9.55245 12.7146L14.3025 7.96456Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckActive);
export default __webpack_public_path__ + "static/media/check_active.3b32ba91bc4f528c2d0337cbb25de3f2.svg";
export { ForwardRef as ReactComponent };